import { UserPermissionEnum } from "@/types/user";
import { TFunction } from "i18next";

export const getTreeData = (t: TFunction<"translation", undefined>) => {
  return [
    {
      title: t("layout.isAdmin"),
      key: UserPermissionEnum.ADMIN,
      children: [
        {
          title: t("layout.salesMana"),
          key: "sale-manager",
          children: [
            {
              title: t("layout.orderRe"),
              key: UserPermissionEnum.SALE_REVIEW,
            },
            {
              title: t("sale.toOfficial"),
              key: UserPermissionEnum.SALE_TO_OFFICIAL,
            },
            {
              title: t("layout.okOrder"),
              key: UserPermissionEnum.SALE_OK_ORDER,
            },
            {
              title: t("order.saleOut"),
              key: UserPermissionEnum.SAEL_OUTBOUND,
            },
            {
              title: t("layout.customMana"),
              key: UserPermissionEnum.SALE_CUSTOMER,
            },
          ],
        },
        {
          title: t("layout.materialControl"),
          key: "mc-manager",
          children: [
            {
              title: t("layout.waitOk"),
              key: UserPermissionEnum.MC_REQUIREMENT,
            },
            {
              title: t("bom.reqManage"),
              key: UserPermissionEnum.REQ_MANAGE,
            },
            {
              title: t("layout.reqM"),
              key: UserPermissionEnum.MC_REQ_M,
            },
            // {
            //   title: t("layout.orderTrack"),
            //   key: UserPermissionEnum.MC_OK_ORDER,
            // },
            {
              title: t("layout.mcDataMt"),
              key: "mc-mt",
              children: [
                {
                  title: t("layout.mcReTemp"),
                  key: UserPermissionEnum.MC_BOM,
                },
                {
                  title: t("layout.inventoryAlert"),
                  key: UserPermissionEnum.MATERIAL_INVENTORY_ALERT,
                },
                {
                  title: t("layout.setInventoryAlert"),
                  key: UserPermissionEnum.MATERIAL_INVENTORY_ALERT_SET,
                },
              ],
            },
          ],
        },
        {
          title: t("layout.commodity"),
          key: "commodity-manager",
          children: [
            {
              title: t("layout.waitOk"),
              key: UserPermissionEnum.CMD_REQUIREMENT,
            },
            {
              title: t("layout.okOrder"),
              key: UserPermissionEnum.CMD_OK_ORDER,
            },
            {
              title: t("layout.productionInfo"),
              key: UserPermissionEnum.SALES_PRODUCT_INFO,
            },
          ],
        },
        {
          title: t("layout.prod"),
          key: "prod-manager",
          children: [
            {
              title: t("layout.waitOk"),
              key: UserPermissionEnum.PR_REQUIREMENT,
            },
            {
              title: t("layout.okOrder"),
              key: UserPermissionEnum.PR_OK_ORDER,
            },
            {
              title: t("layout.productData"),
              key: UserPermissionEnum.PR_REPORT_ENTRY,
            },
            {
              title: t("layout.orderProdMt"),
              key: UserPermissionEnum.PR_REPORT_MT,
            },
            {
              title: t("layout.factoryInventory"),
              key: UserPermissionEnum.FAC_INVENTORY,
            },
          ],
        },
        {
          title: t("layout.purchaseMana"),
          key: "pur-manager",
          children: [
            {
              title: t("layout.waitOk"),
              key: UserPermissionEnum.PUR_REQUIREMENT
            },
            // {
            //   title: t("layout.orderTrack"),
            //   key: UserPermissionEnum.PUR_OK_ORDER,
            // },
            {
              title: t("layout.purOrder"),
              key: "pur-order-ma",
              children: [
                {
                  title: t("layout.requirementPurchase"),
                  key: UserPermissionEnum.PUR_REQUIREMENT_ORDER
                },
                {
                  title: t("purchase.orderList"),
                  key: UserPermissionEnum.PUR_ORDER,
                },
                {
                  title: t("sale.addOrder"),
                  key: UserPermissionEnum.PUR_ORDER_ADD,
                },
                {
                  title: t("sale.editOrder"),
                  key: UserPermissionEnum.PUR_ORDER_EDIT,
                },
                {
                  title: t("purchase.helpAcc"),
                  key: UserPermissionEnum.PUR_HELP_ACCEPT,
                },
                {
                  title: t("layout.purInvItem"),
                  key: UserPermissionEnum.PUR_INV_ITEM,
                },
              ],
            },
            {
              title: t("layout.purOrderMt"),
              key: "pur-mt",
              children: [
                {
                  title: t("layout.supplierMana"),
                  key: UserPermissionEnum.PUR_SUPPLIER,
                },
                {
                  title: t("layout.priceList"),
                  key: UserPermissionEnum.PUR_PRICES,
                },
                {
                  title: t("layout.gategoryManage"),
                  key: UserPermissionEnum.PUR_QUO_PRO_LIST,
                },
                {
                  title: t("layout.quotationManage"),
                  key: UserPermissionEnum.PUR_QUO_MAN,
                },
              ],
            },
            {
              title: t("purchase.pdaPrint"),
              key: UserPermissionEnum.PDA_PRINT_PUR
            },
            {
              title: t("layout.purchaseOperation"),
              key: UserPermissionEnum.PURCHASE_OPTION,
              children: [
                {
                  title: t("layout.manualQuotation"),
                  key: UserPermissionEnum.PURCHASE_OPTION_MANUAL,
                },
                {
                  title: t("layout.materialTracking"),
                  key: UserPermissionEnum.PURCHASE_MATERIAL_TRACK,
                },
                {
                  title: t("layout.returnAndExchange"),
                  key: UserPermissionEnum.PURCHASE_RETURN,
                },
              ]
            }
          ],
        },
        {
          title: t("layout.finance"),
          key: "finance-ok",
          children: [
            {
              title: t("layout.waitOk"),
              key: UserPermissionEnum.FINANCE_REQUIREMENT
            },
             {
              title: t("layout.saleOrderFinish"),
              key: UserPermissionEnum.FINANCE_SALE_ORDER_FINISH,
            },
            // {
            //   title: t("layout.orderTrack"),
            //   key: UserPermissionEnum.FINANCE_OK_ORDER,
            // },
          ],
        },
        {
          title: t("layout.invnManag"),
          key: "store-manager",
          children: [
            {
              title: t("layout.warehousePreparation"),
              key: UserPermissionEnum.STORE_WAREHOUSE_PREPARATION,
            },
            {
              title: t("layout.warehouseManagement"),
              key: 'warehouse-manage',
              children: [
                {
                  title: t("layout.warehouseManagement"),
                  key: UserPermissionEnum.STORE_WAREHOUSE_MANAGEMENT,
                },
                {
                  title: t("warehouse.inbound"),
                  key: UserPermissionEnum.ACT_STORE_IN,
                },
                {
                  title: t("warehouse.outbound"),
                  key: UserPermissionEnum.ACT_STORE_OUT,
                },
                {
                  title: t("warehouse.tempIn"),
                  key: UserPermissionEnum.TEMP_INBOUND,
                },
                {
                  title: t("warehouse.prodTempIn"),
                  key: UserPermissionEnum.TEMP_INBOUND_PRODUCT,
                },
                {
                  title: t("warehouse.otherOut"),
                  key: UserPermissionEnum.OTHER_OUTBOUND,
                },
              ],
            },
            {
              title: t("layout.inOutDetail"),
              key: UserPermissionEnum.WAREHOUSE_INVENTORY_DETAIL,
            },
            {
              title: t("layout.locInvDetail"),
              key: UserPermissionEnum.LOC_INV_DTL,
            },
            {
              title: t("layout.operationStatus"),
              key: UserPermissionEnum.STORE_ORDER,
            },
            {
              title: t("layout.locationManagement"),
              key: UserPermissionEnum.STORE_LOCATION_MANAGEMENT,
            },
            {
              title: t("layout.locationRefProducts"),
              key: UserPermissionEnum.STORE_LOCATION_REF_PRODUCTS,
            },
            {
              title: t("layout.invnHistory"),
              key: UserPermissionEnum.STORE_COUNTING_HISTORY,
              children: [
                {
                  title: t("layout.invnHistory"),
                  key: UserPermissionEnum.STORE_COUNTING,
                },
                {
                  title: t("counting.startInv"),
                  key: UserPermissionEnum.ACT_STORE_COUNTING,
                },
              ],
            },
            {
              title: t("warehouse.iqcList"),
              key: UserPermissionEnum.WAREHOUSE_IQC,
            },
            {
              title: t("warehouse.packing"),
              key: UserPermissionEnum.PACKING,
            },
            {
              title: t("inspection.inspection"),
              key: UserPermissionEnum.INSPECTION,
            },
            {
              title: t("inspection.config"),
              key: UserPermissionEnum.INSP_CONFIG_PRO,
            },
            {
              title: t("inspection.inspectItem"),
              key: UserPermissionEnum.INSP_ITEM,
            },
          ],
        },
        {
          title: t("shipment.shipmentMana"),
          key: "shipment-manager",
          children: [
            {
              title: t("shipment.shipmentListPage"),
              key: UserPermissionEnum.SHIPMENT_LIST,
            },
          ],
        },
        {
          title: t("layout.dataModule"),
          key: "data-manager",
          children: [
            {
              title: t("layout.orderReport"),
              key: UserPermissionEnum.DATA_ORDER_REPORT,
            },
          ],
        },
        {
          title: t("layout.orgManag"),
          key: "org-manager",
          children: [
            {
              title: t("layout.orgManag"),
              key: UserPermissionEnum.ORG_PREVIEW,
              disabled: true,
            },
            {
              title: t("org.addOrg"),
              key: UserPermissionEnum.ORG_ADD,
            },
          ],
        },
        {
          title: t("layout.memberManag"),
          key: UserPermissionEnum.MEMBER_LIST,
        },
        {
          title: t("layout.categoryManag"),
          key: "category-manager",
          children: [
            {
              title: t("layout.categoryManag"),
              key: UserPermissionEnum.PRODUCT_ADD_CATEGORY_LIST,
            },
            {
              title: t("category.editCategoryInfo"),
              key: UserPermissionEnum.PRODUCT_CATEGORY_EDIT_INFO,
            },
            {
              title: t("category.addOrEditCategoryProduct"),
              key: UserPermissionEnum.PRODUCT_CATEGORY_ADD_OR_EDIT,
            },
            {
              title: t("category.setCategoryOrg"),
              key: UserPermissionEnum.PRODUCT_CATEGORY_ORG_SET,
            },
          ],
        },
        {
          title: t("layout.productList"),
          key: "product-list-manager",
          children: [
            {
              title: t("layout.productList"),
              key: UserPermissionEnum.PRODUCT_LIST,
            },
            {
              title: t("category.addOrEditProduct"),
              key: UserPermissionEnum.PRODUCT_ADD,
            },
          ],
        },
        {
          title: t("layout.APPManagement"),
          key: UserPermissionEnum.APP_LIST,
        },
        {
          title: t("layout.DATAManage"),
          key: "data-manage-supplier",
          children: [
            {
              title: t("layout.supplierMana"),
              key: UserPermissionEnum.DATA_MANAGE_SUPPLIER,
            },
          ]
        },
        {
          title: t("layout.preferences"),
          key: "system-setting",
          children: [
            {
              title: t("layout.printSetting"),
              key: UserPermissionEnum.SETTINGS_PRINTING,
            },
            {
              title: t("layout.typeManage"),
              key: UserPermissionEnum.SETTINGS_QUO_TYPE,
            },
            {
              title: t("layout.setExchange"),
              key: UserPermissionEnum.SETTINGS_CURR,
            },
            {
              title: t("layout.addressM"),
              key: UserPermissionEnum.SETTINGS_ADDRESS,
            },
            {
              title: t("layout.purchaseRuleSet"),
              key: UserPermissionEnum.PRINT_RULE_SETTING,
            },
          ]
        },
        {
          title: t("layout.reimburseMana"),
          key: "reimburse-manager",
          children: [
            {
              title: t("layout.allApplications"),
              key: UserPermissionEnum.REIMBURSE_ALL,
            },
          ],
        },
        {
          title: t("layout.equipmentManagement"),
          key: "equipment-manager",
          children: [
            {
              title: t("layout.equipmentManagement"),
              key: UserPermissionEnum.EQUIPMENT_MANAGEMENT,
            },
            {
              title: t("equipment.addOrEditEquipmentCategory"),
              key: UserPermissionEnum.EQUIPMENT_CATEGORY_ADD_OR_EDIT,
            },
            {
              title: t("equipment.addOrEditEquipmentInfo"),
              key: UserPermissionEnum.EQUIPMENT_ADD_OR_EDIT,
            },
          ],
        },
      ],
    },
  ];
};
